(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["camelea-box-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('camelea-box-quiz')) {
    customElements.define('camelea-box-quiz', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        const signal = this.abortController.signal;
        const dialog = this.querySelector('dialog');
        const steps = [...this.querySelectorAll('[data-quiz-step]')];
        const next = this.querySelector('[data-quiz-next]');
        const result = this.querySelector('[data-quiz-result]');
        const key = 'camelea-box-quiz-seen';
        const setStep = number => {
          steps.forEach(step => { step.hidden = Number(step.dataset.quizStep) !== number; });
          steps[number - 1].querySelector('legend, h3')?.focus();
        };
        const open = () => {
          if (dialog.open || document.querySelector('dialog[open]')) return;
          dialog.showModal();
          try { sessionStorage.setItem(key, '1'); } catch {}
        };
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-quiz-open')) open();
          if (button.hasAttribute('data-quiz-close')) dialog.close();
          if (button.hasAttribute('data-quiz-next')) setStep(2);
          if (button.hasAttribute('data-quiz-back')) setStep(1);
          if (button.hasAttribute('data-quiz-result')) {
            const desire = Number(steps[0].querySelector('input:checked')?.value);
            const budget = Number(steps[1].querySelector('input:checked')?.value);
            if (!desire || !budget) return;
            const choice = Math.min(desire, budget);
            this.querySelectorAll('[data-quiz-recommendation]').forEach(article => { article.hidden = Number(article.dataset.quizRecommendation) !== choice; });
            setStep(3);
          }
          if (button.hasAttribute('data-quiz-restart')) {
            this.querySelectorAll('input').forEach(input => { input.checked = false; });
            next.disabled = true;
            result.disabled = true;
            setStep(1);
          }
        }, { signal });
        this.addEventListener('change', () => {
          next.disabled = !steps[0].querySelector('input:checked');
          result.disabled = !steps[1].querySelector('input:checked');
        }, { signal });
        dialog.addEventListener('click', event => { if (event.target === dialog && event.clientX !== 0) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } }, { signal });
        if (this.dataset.autoOpen === 'true' && !window.Shopify?.designMode) {
          this.readyForAuto = false;
          const maybeOpen = () => {
            let seen = true;
            try { seen = sessionStorage.getItem(key) === '1'; } catch {}
            const page = this.closest('.page-wrapper') || document.scrollingElement;
            const scrollTop = Math.max(window.scrollY, page?.scrollTop || 0);
            if (!seen && this.readyForAuto && scrollTop > window.innerHeight * .35 && !document.activeElement?.matches('input, textarea, select')) open();
          };
          this.autoTimer = setTimeout(() => { this.readyForAuto = true; maybeOpen(); }, 20000);
          document.addEventListener('scroll', maybeOpen, { capture: true, passive: true, signal });
        }
      }
      disconnectedCallback() { this.abortController?.abort(); clearTimeout(this.autoTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
